import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkDirective from "remark-directive";
import { visit } from "unist-util-visit";

/**
 * Преобразует ::: blocks (remark-directive) в hAST-узлы с классом
 * admonition-{type}. Поддерживаем 5 типов; остальные имена игнорируем.
 *
 * Типизация плагина намеренно широкая — типы `unified`/`hast` не
 * установлены отдельно как deps, тащить их ради trivial плагина не стоит.
 */
const ADMONITIONS = new Set(["important", "example", "mistake", "script", "tip"]);

function remarkAdmonitions() {
  return (tree: unknown) => {
    visit(tree as never, (node: unknown) => {
      const n = node as { type?: string; name?: string; data?: Record<string, unknown> };
      if (n.type === "containerDirective" && n.name && ADMONITIONS.has(n.name)) {
        n.data = n.data || {};
        n.data.hName = "div";
        n.data.hProperties = { className: `admonition admonition-${n.name}` };
      }
    });
  };
}

interface Props {
  source: string;
}

export function LessonMarkdown({ source }: Props) {
  return (
    <div className="lesson-prose">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkDirective, remarkAdmonitions]}
        components={{
          a: ({ href, children, ...rest }) => {
            if (!href) {
              return <a {...rest}>{children}</a>;
            }
            const isExternal = /^https?:\/\//.test(href);
            return (
              <a
                href={href}
                {...(isExternal
                  ? { target: "_blank", rel: "noreferrer noopener" }
                  : {})}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {source}
      </ReactMarkdown>
    </div>
  );
}
